import React from "react";
import { connect } from "react-redux";
import * as echarts from "echarts";
import {incomeExpenseCatPieChartOption} from "../../Data/Charts";

class IncomeExpenseByCategoriesPieChart extends React.Component {
  componentDidMount() {
    this.chartPlace();
  }
  componentDidUpdate(prevProps:Readonly<P>, prevState:Readonly<S>, snapshot:SS) {
    if (prevProps.incomeExpensePieChartData !== this.props.incomeExpensePieChartData) {
      this.chartPlace();
    }
  }
  chartPlace = () => {
    const {incomeExpensePieChartData} = this.props

    const optionPieEchart = incomeExpenseCatPieChartOption(incomeExpensePieChartData);

    var chartDom = document.getElementById("IncomeExpenseByCategoriesPieChart");
    var myChart = echarts.init(chartDom);
    var option;
    option = optionPieEchart;

    option && myChart.setOption(option);
  };
  render() {
    return (
      <div>

          <div className="body">
            <div id="IncomeExpenseByCategoriesPieChart" style={{ height: 300 }}></div>
            {/* <ReactEcharts
                        option={optionPieEchart}
                        opts={{renderer: 'svg'}} // use svg to render the chart.
                    /> */}
          </div>
        </div>
    );
  }
}

const mapStateToProps = (state) => ({
  incomeExpensePieChartData: state.analyticalReducer.incomeExpensePieChartData,
});

export default connect(mapStateToProps, {})(IncomeExpenseByCategoriesPieChart);
